"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _AccessParticipantParams = _interopRequireDefault(require("../model/AccessParticipantParams"));
var _AddParticipantParams = _interopRequireDefault(require("../model/AddParticipantParams"));
var _DeleteParticipantParams = _interopRequireDefault(require("../model/DeleteParticipantParams"));
var _EditFollowUpListParams = _interopRequireDefault(require("../model/EditFollowUpListParams"));
var _EditInstitutionParams = _interopRequireDefault(require("../model/EditInstitutionParams"));
var _EditParticipantParams = _interopRequireDefault(require("../model/EditParticipantParams"));
var _ErrorResponse = _interopRequireDefault(require("../model/ErrorResponse"));
var _InstitutionsGetProgramGroupsPost200ResponseInner = _interopRequireDefault(require("../model/InstitutionsGetProgramGroupsPost200ResponseInner"));
var _InstitutionsGetProgramGroupsPostRequest = _interopRequireDefault(require("../model/InstitutionsGetProgramGroupsPostRequest"));
var _InstitutionsGetUserProgramsStatisticsPost200ResponseInner = _interopRequireDefault(require("../model/InstitutionsGetUserProgramsStatisticsPost200ResponseInner"));
var _InstitutionsGetUserProgramsStatisticsPostRequest = _interopRequireDefault(require("../model/InstitutionsGetUserProgramsStatisticsPostRequest"));
var _InstitutionsInviteUserPost200Response = _interopRequireDefault(require("../model/InstitutionsInviteUserPost200Response"));
var _InstitutionsSetProgramGroupsUserConfigPostRequest = _interopRequireDefault(require("../model/InstitutionsSetProgramGroupsUserConfigPostRequest"));
var _InviteUserParams = _interopRequireDefault(require("../model/InviteUserParams"));
var _Language = _interopRequireDefault(require("../model/Language"));
var _ProgramGroupInstitutionUserConfigResponseBody = _interopRequireDefault(require("../model/ProgramGroupInstitutionUserConfigResponseBody"));
var _ProgramsUpdateProgramProgressPost200Response = _interopRequireDefault(require("../model/ProgramsUpdateProgramProgressPost200Response"));
var _ResendParticipantActivationEmailParams = _interopRequireDefault(require("../model/ResendParticipantActivationEmailParams"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Manage My Pain API
 * This document provide full documentation for [ManagingLife](http://managinglife.com) API # Introduction Each API call only supports POST calls, and all parameters goes to body of POST request<br> Format of each API endpoint is `https://SERVER.managinglife.com/api/vVERSION/SERVICE/METHOD`   - **SERVER** could be one of: *dev*, *preprod*, *sync*.   - **VERSION** could be one of: *1*, *3*, *4*.   - **SERVICE** e.g. *core*, *sync*, *alerts*.   - **METHOD** e.g. *generate-report*, *login-user*, *update-records*.  Any parameter that is not marked as required can be null or omitted. # Client libraries We also provide several client libraries which were auto-generated using swagger-codegen.   - [JavaScript](/codegen/javascript)   - [Java](/codegen/java)   - [PHP](/codegen/php)   - [Objective C](/codegen/objc) # Authentication <!-- ReDoc-Inject: <security-definitions> --> 
 *
 * The version of the OpenAPI document: 4.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
* InstitutionAdmin service.
* @module api/InstitutionAdminApi
* @version 4.0.0
*/
var InstitutionAdminApi = exports["default"] = /*#__PURE__*/function () {
  /**
  * Constructs a new InstitutionAdminApi. 
  * @alias module:api/InstitutionAdminApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function InstitutionAdminApi(apiClient) {
    _classCallCheck(this, InstitutionAdminApi);
    this.apiClient = apiClient || _ApiClient["default"].instance;
  }

  /**
   * access-participant
   * Log info about Institution admin access to participants personal data.
   * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
   * @param {module:model/AccessParticipantParams} params 
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ErrorResponse} and HTTP response
   */
  return _createClass(InstitutionAdminApi, [{
    key: "institutionsAccessParticipantPostWithHttpInfo",
    value: function institutionsAccessParticipantPostWithHttpInfo(Accept_Language, params) {
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling institutionsAccessParticipantPost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling institutionsAccessParticipantPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = ['token'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ErrorResponse["default"];
      return this.apiClient.callApi('/institutions/access-participant', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * access-participant
     * Log info about Institution admin access to participants personal data.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/AccessParticipantParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ErrorResponse}
     */
  }, {
    key: "institutionsAccessParticipantPost",
    value: function institutionsAccessParticipantPost(Accept_Language, params) {
      return this.institutionsAccessParticipantPostWithHttpInfo(Accept_Language, params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * add-participant
     * Creates an association between a user and the institution as a participant, or an admin. This API call is only used in the Web Portal for adding new View-only Admins (via User Access Management modal window). It should not be used for adding Participants, as the user should intiate the request after providing consent.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/AddParticipantParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */
  }, {
    key: "institutionsAddParticipantPostWithHttpInfo",
    value: function institutionsAddParticipantPostWithHttpInfo(Accept_Language, params) {
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling institutionsAddParticipantPost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling institutionsAddParticipantPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = ['token'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/institutions/add-participant', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * add-participant
     * Creates an association between a user and the institution as a participant, or an admin. This API call is only used in the Web Portal for adding new View-only Admins (via User Access Management modal window). It should not be used for adding Participants, as the user should intiate the request after providing consent.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/AddParticipantParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */
  }, {
    key: "institutionsAddParticipantPost",
    value: function institutionsAddParticipantPost(Accept_Language, params) {
      return this.institutionsAddParticipantPostWithHttpInfo(Accept_Language, params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * delete-participant
     * Removes the association of the user and the institution.  The user's account will not be modified.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/DeleteParticipantParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */
  }, {
    key: "institutionsDeleteParticipantPostWithHttpInfo",
    value: function institutionsDeleteParticipantPostWithHttpInfo(Accept_Language, params) {
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling institutionsDeleteParticipantPost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling institutionsDeleteParticipantPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = ['token'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/institutions/delete-participant', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * delete-participant
     * Removes the association of the user and the institution.  The user's account will not be modified.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/DeleteParticipantParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */
  }, {
    key: "institutionsDeleteParticipantPost",
    value: function institutionsDeleteParticipantPost(Accept_Language, params) {
      return this.institutionsDeleteParticipantPostWithHttpInfo(Accept_Language, params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * edit-follow-up-list
     * API-call allows to store and modify the list of the patients UIDs followed by the Institutional Admin within the specified Institution.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/EditFollowUpListParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ErrorResponse} and HTTP response
     */
  }, {
    key: "institutionsEditFollowUpListPostWithHttpInfo",
    value: function institutionsEditFollowUpListPostWithHttpInfo(Accept_Language, params) {
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling institutionsEditFollowUpListPost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling institutionsEditFollowUpListPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = ['token'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ErrorResponse["default"];
      return this.apiClient.callApi('/institutions/edit-follow-up-list', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * edit-follow-up-list
     * API-call allows to store and modify the list of the patients UIDs followed by the Institutional Admin within the specified Institution.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/EditFollowUpListParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ErrorResponse}
     */
  }, {
    key: "institutionsEditFollowUpListPost",
    value: function institutionsEditFollowUpListPost(Accept_Language, params) {
      return this.institutionsEditFollowUpListPostWithHttpInfo(Accept_Language, params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * edit-institution
     * Edit _institution_
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/EditInstitutionParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */
  }, {
    key: "institutionsEditInstitutionPostWithHttpInfo",
    value: function institutionsEditInstitutionPostWithHttpInfo(Accept_Language, params) {
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling institutionsEditInstitutionPost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling institutionsEditInstitutionPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = ['token'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/institutions/edit-institution', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * edit-institution
     * Edit _institution_
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/EditInstitutionParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */
  }, {
    key: "institutionsEditInstitutionPost",
    value: function institutionsEditInstitutionPost(Accept_Language, params) {
      return this.institutionsEditInstitutionPostWithHttpInfo(Accept_Language, params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * edit-participant
     * Edits the parameters of the user's association with the institution.  The user's account will not be modified.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/EditParticipantParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */
  }, {
    key: "institutionsEditParticipantPostWithHttpInfo",
    value: function institutionsEditParticipantPostWithHttpInfo(Accept_Language, params) {
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling institutionsEditParticipantPost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling institutionsEditParticipantPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = ['token'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/institutions/edit-participant', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * edit-participant
     * Edits the parameters of the user's association with the institution.  The user's account will not be modified.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/EditParticipantParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */
  }, {
    key: "institutionsEditParticipantPost",
    value: function institutionsEditParticipantPost(Accept_Language, params) {
      return this.institutionsEditParticipantPostWithHttpInfo(Accept_Language, params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * get-program-groups
     * Return the list of program groups which are available for current institution
     * @param {Object} opts Optional parameters
     * @param {module:model/InstitutionsGetProgramGroupsPostRequest} [InstitutionsGetProgramGroupsPostRequest] 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/InstitutionsGetProgramGroupsPost200ResponseInner>} and HTTP response
     */
  }, {
    key: "institutionsGetProgramGroupsPostWithHttpInfo",
    value: function institutionsGetProgramGroupsPostWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['InstitutionsGetProgramGroupsPostRequest'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['token'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = [_InstitutionsGetProgramGroupsPost200ResponseInner["default"]];
      return this.apiClient.callApi('/institutions/get-program-groups', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * get-program-groups
     * Return the list of program groups which are available for current institution
     * @param {Object} opts Optional parameters
     * @param {module:model/InstitutionsGetProgramGroupsPostRequest} opts.InstitutionsGetProgramGroupsPostRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/InstitutionsGetProgramGroupsPost200ResponseInner>}
     */
  }, {
    key: "institutionsGetProgramGroupsPost",
    value: function institutionsGetProgramGroupsPost(opts) {
      return this.institutionsGetProgramGroupsPostWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * get-program-groups-user-config
     * Return the list of program groups configs for given institution participant
     * @param {Object} opts Optional parameters
     * @param {module:model/InstitutionsGetUserProgramsStatisticsPostRequest} [InstitutionsGetUserProgramsStatisticsPostRequest] 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/ProgramGroupInstitutionUserConfigResponseBody>} and HTTP response
     */
  }, {
    key: "institutionsGetProgramGroupsUserConfigPostWithHttpInfo",
    value: function institutionsGetProgramGroupsUserConfigPostWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['InstitutionsGetUserProgramsStatisticsPostRequest'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['token'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = [_ProgramGroupInstitutionUserConfigResponseBody["default"]];
      return this.apiClient.callApi('/institutions/get-program-groups-user-config', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * get-program-groups-user-config
     * Return the list of program groups configs for given institution participant
     * @param {Object} opts Optional parameters
     * @param {module:model/InstitutionsGetUserProgramsStatisticsPostRequest} opts.InstitutionsGetUserProgramsStatisticsPostRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/ProgramGroupInstitutionUserConfigResponseBody>}
     */
  }, {
    key: "institutionsGetProgramGroupsUserConfigPost",
    value: function institutionsGetProgramGroupsUserConfigPost(opts) {
      return this.institutionsGetProgramGroupsUserConfigPostWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * get-user-programs-statistics
     * Provides information about user programs usage progress
     * @param {Object} opts Optional parameters
     * @param {module:model/InstitutionsGetUserProgramsStatisticsPostRequest} [InstitutionsGetUserProgramsStatisticsPostRequest] 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/InstitutionsGetUserProgramsStatisticsPost200ResponseInner>} and HTTP response
     */
  }, {
    key: "institutionsGetUserProgramsStatisticsPostWithHttpInfo",
    value: function institutionsGetUserProgramsStatisticsPostWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['InstitutionsGetUserProgramsStatisticsPostRequest'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['token'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = [_InstitutionsGetUserProgramsStatisticsPost200ResponseInner["default"]];
      return this.apiClient.callApi('/institutions/get-user-programs-statistics', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * get-user-programs-statistics
     * Provides information about user programs usage progress
     * @param {Object} opts Optional parameters
     * @param {module:model/InstitutionsGetUserProgramsStatisticsPostRequest} opts.InstitutionsGetUserProgramsStatisticsPostRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/InstitutionsGetUserProgramsStatisticsPost200ResponseInner>}
     */
  }, {
    key: "institutionsGetUserProgramsStatisticsPost",
    value: function institutionsGetUserProgramsStatisticsPost(opts) {
      return this.institutionsGetUserProgramsStatisticsPostWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * invite-user
     * Send an email to provided email address. Existing activation code will be used if not expired. It will be recreated if expired. If no activation code exists for the provided pair of institution ID and email address, new one will be created.<br> If user with the provided email address doesn't exist in ManagingLife system, email with registration link will be sent. If user exists, email with join institution link will be sent.  If user already a member of institution, error 305 will be received in responce. 
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/InviteUserParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/InstitutionsInviteUserPost200Response} and HTTP response
     */
  }, {
    key: "institutionsInviteUserPostWithHttpInfo",
    value: function institutionsInviteUserPostWithHttpInfo(Accept_Language, params) {
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling institutionsInviteUserPost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling institutionsInviteUserPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = ['token'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _InstitutionsInviteUserPost200Response["default"];
      return this.apiClient.callApi('/institutions/invite-user', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * invite-user
     * Send an email to provided email address. Existing activation code will be used if not expired. It will be recreated if expired. If no activation code exists for the provided pair of institution ID and email address, new one will be created.<br> If user with the provided email address doesn't exist in ManagingLife system, email with registration link will be sent. If user exists, email with join institution link will be sent.  If user already a member of institution, error 305 will be received in responce. 
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/InviteUserParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/InstitutionsInviteUserPost200Response}
     */
  }, {
    key: "institutionsInviteUserPost",
    value: function institutionsInviteUserPost(Accept_Language, params) {
      return this.institutionsInviteUserPostWithHttpInfo(Accept_Language, params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * resend-participant-activation-email
     * Resend activation email to user with provided uid. Email only sent if requested by institution admin, user with uid exists and user is not activated yet. 
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/ResendParticipantActivationEmailParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/InstitutionsInviteUserPost200Response} and HTTP response
     */
  }, {
    key: "institutionsResendParticipantActivationEmailPostWithHttpInfo",
    value: function institutionsResendParticipantActivationEmailPostWithHttpInfo(Accept_Language, params) {
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling institutionsResendParticipantActivationEmailPost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling institutionsResendParticipantActivationEmailPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = ['token'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _InstitutionsInviteUserPost200Response["default"];
      return this.apiClient.callApi('/institutions/resend-participant-activation-email', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * resend-participant-activation-email
     * Resend activation email to user with provided uid. Email only sent if requested by institution admin, user with uid exists and user is not activated yet. 
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/ResendParticipantActivationEmailParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/InstitutionsInviteUserPost200Response}
     */
  }, {
    key: "institutionsResendParticipantActivationEmailPost",
    value: function institutionsResendParticipantActivationEmailPost(Accept_Language, params) {
      return this.institutionsResendParticipantActivationEmailPostWithHttpInfo(Accept_Language, params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * set-program-groups-user-config
     * Set the list of program groups configs for given institution participant
     * @param {Object} opts Optional parameters
     * @param {module:model/InstitutionsSetProgramGroupsUserConfigPostRequest} [InstitutionsSetProgramGroupsUserConfigPostRequest] 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ProgramsUpdateProgramProgressPost200Response} and HTTP response
     */
  }, {
    key: "institutionsSetProgramGroupsUserConfigPostWithHttpInfo",
    value: function institutionsSetProgramGroupsUserConfigPostWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['InstitutionsSetProgramGroupsUserConfigPostRequest'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['token'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ProgramsUpdateProgramProgressPost200Response["default"];
      return this.apiClient.callApi('/institutions/set-program-groups-user-config', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * set-program-groups-user-config
     * Set the list of program groups configs for given institution participant
     * @param {Object} opts Optional parameters
     * @param {module:model/InstitutionsSetProgramGroupsUserConfigPostRequest} opts.InstitutionsSetProgramGroupsUserConfigPostRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ProgramsUpdateProgramProgressPost200Response}
     */
  }, {
    key: "institutionsSetProgramGroupsUserConfigPost",
    value: function institutionsSetProgramGroupsUserConfigPost(opts) {
      return this.institutionsSetProgramGroupsUserConfigPostWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);
}();